(function () {
    'use strict';

    angular.module('swif.fluid')

    .config(
        function($routeProvider) {
            'ngInject';
            $routeProvider.when('/fluid/meter/table_view', {
                templateUrl: 'partials/fluid/meter_table_view.html',
                controller: 'FluidMetersController',
                reloadOnSearch: false
            });
        }
    )

    .controller('FluidMetersController',
        function ($scope, swif) {
            'ngInject';

            console.log('init FluidMetersController');
            swif.collection.createOrUpdate('fluids_meters', 'fluids_meter')
                .then(function (collection) {
                    $scope.fluids_meters = collection;
                });

            $scope.callback = function (error, data) {
                $scope.fluids_meters.fasterCallback(data);
            };

            $scope.preModal = function (data) {
                // Retrieve site repartitions on edit
                if (data.action.id == 'edit' && data.model._type == 'fluids_meter') {
                    var filters = {};

                    swif.data.addFilter(filters, 'meter_id', '=', data.model.id);
                    swif.data.get('fluids_site_repartition', undefined, filters).then(
                        function (site_repartitions) {
                            data.model.site_repartitions = site_repartitions;
                        });
                }
            };

            $scope.preValidate = function (data) {
                // Replace site_repartitions site ids
                angular.forEach(data.model.site_repartitions, function (item) {
                    item.site_id = item.site_id[0];
                });

                return data;
            };
        }
    )

    .controller('FluidMeterController',
        function ($scope, swif) {
            'ngInject';
            console.log('init FluidMeterController');

            // Initialize filters
            $scope.filters = {
                categ_id: {},
                site_repartitions: {}
            };

            $scope.selected = {};

            // Add product category filter (is_fluid_meter)
            swif.data.addFilter($scope.filters.categ_id, 'is_fluid_meter', '=', true);

            /**
             * Add a new repartition on a site when the selection changes
             */
            $scope.onRepartitionChange = function (site) {
                // Initialize site repartitions if necessary
                if (!$scope.model.site_repartitions) {
                    $scope.model.site_repartitions = [];
                }

                if (site.id) {
                    // Append the site repartition to the list
                    $scope.model.site_repartitions.push({
                        site_id: [site.id, site.complete_name],
                        value: 100
                    });

                    // Reset selection
                    $scope.selected = {};
                }
            };

            /**
             * Delete a site repartition
             */
            $scope.deleteRepartition = function (site_repartition) {
                var index = $scope.model.site_repartitions.indexOf(site_repartition);

                if (index !== -1) {
                    $scope.model.site_repartitions.splice(index, 1);
                }
            }

            /**
             * Watch for site repartitions changes and update site
             * filter and repartitions total accordingly
             */
            $scope.$watch('model.site_repartitions', function (site_repartitions) {
                // Rebuild site filter
                $scope.filters.site_repartitions = {};

                // If there's no repartitions, set validity and stop here
                if (!site_repartitions || !site_repartitions.length) {
                    $scope.form.$setValidity('repartitionsTotal', true);
                    $scope.repartitionsTotal = 0;
                    return;
                }

                // Exclude selected sites
                swif.data.addFilter(
                    $scope.filters.site_repartitions,
                    'id', 'not in', _.map(site_repartitions, function (item) {
                        return item.site_id[0];
                    }));

                // Compute the total repartition value
                $scope.repartitionsTotal = _.reduce(site_repartitions, function (sum, item) {
                    return sum + item.value;
                }, 0).toFixed(2);

                $scope.form.$setValidity('repartitionsTotal', $scope.repartitionsTotal == 100);
            }, true);

            /**
             * Watch for reference changes and query backend to
             * check unicity
             */
            $scope.$watch('model.ref', function (newRef, oldRef) {
                if (!newRef && !oldRef || newRef == oldRef) {
                    return;
                }

                var params = {
                    fields: ['id'],
                    domain: [
                        ['ref', '=', newRef]
                    ]
                };

                // Exclude current object id
                if ($scope.model._type == 'fluids_meter' && $scope.model.id) {
                    params.domain.push(['id', '!=', $scope.model.id]);
                }

                // Send request
                swif.data.searchRead('fluids_meter', params).then(function (results) {
                    // Form field is valid only when there's no other meter
                    // with the same ref
                    $scope.form.ref.$setValidity('unique', results.length === 0);
                });
            });
        }
    );
})();
